// document.addEventListener('DOMContentLoaded', function () {
// }); // end DOMContentLoaded / onReady

window.addEventListener('load', function (event) {
  // console.log("All resources finished loading!");
  pageLoad();
  loadHoverLoops();
});

let superboxes = [];

function pageLoad() {

  superboxes = document.querySelectorAll(".game-superbox");
  // console.log(superboxes);


  superboxes.forEach(box => {
    var i = box.getAttribute('data-game');
    var gif = document.querySelector(`[data-gif="${i}"]`);
    // console.log('box: ', i, ' with gif: ', gif);
    if (gif) {
      addEvent(box, "mouseenter", function (e) {
        // console.log('inside mouse', box);
        box.classList.add('gifplaying');
        playmp4(gif);
      });
      addEvent(box, "touchstart", function (e) {
        pauseAndHideAllMp4s();
        // console.log('inside touch', box);
        box.classList.add('gifplaying');
        playmp4(gif);
      });
      addEvent(box, "mouseleave", function (e) {
        // console.log('outside', box);
        box.classList.remove('gifplaying');
        pausemp4(gif);
      });
    }
  });
}

// mp4-as-GIF autoplay code
// https://git.io/vH4Ek
var supports_video_autoplay = function (callback) {

  var v = document.createElement("video");
  v.paused = true;
  var p = false;
  try {
    p = "play" in v && v.play();
  } catch (err) {

  }
  typeof callback === "function" && callback(!v.paused || "Promise" in window && p instanceof Promise);

};

var supports_mp4_in_img = function (callback) {

  var image = new Image();

  image.onload = function () {
    var isSupported = image.width > 0 && image.height > 0;
    callback(isSupported);
  };

  image.onerror = function () {
    callback(false);
  };
  image.src = 'data:video/mp4;base64,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';
}

function loadHoverLoops() {
  supports_video_autoplay(function (supportsAutoplay) {
    supports_mp4_in_img(function (supportsMP4InImg) {
      if (supportsMP4InImg) {
        var videos = document.querySelectorAll('[data-gif]');

        [].forEach.call(videos, function (video) {
          video.removeAttribute('controls');
          var img = new Image();
          img.src = video.querySelector('source').src;
          img.setAttribute('alt', "");
          if (img.decode) {
            img.decode().then(function () { 
              video.parentNode.replaceChild(img, video);
            });
          } else {
            img.onload = function () {
              video.parentNode.replaceChild(img, video);
            }
          }
        });
      } else {
        var saveData = navigator.connection && navigator.connection.saveData;
        if (supportsAutoplay && !saveData) {
          var videos = document.querySelectorAll('[data-gif]');

          // observer = new IntersectionObserver(entries => {
          //     entries.forEach(entry => {
          //         var video = entry.target;
          //         if (entry.intersectionRatio > 0) {
          //             // video is in the viewport - start it
          //             playmp4(video);
          //         } else {
          //             // video is outside the viewport - pause it
          //             pausemp4(video);
          //         }
          //     });
          // });

          [].forEach.call(videos, function (video) {
            video.removeAttribute('controls');

            // observer.observe(video);

          });
        } else {
          // no video autoplay support :(
        }
      }
    });
  });
};


function addEvent(obj, evt, fn) {
  if (obj.addEventListener) {
    obj.addEventListener(evt, fn, false);
  }
  else if (obj.attachEvent) {
    obj.attachEvent("on" + evt, fn);
  }
}

function playmp4(video) {
  video.setAttribute('autoplay', true);
  video.setAttribute('loop', true);
  video.removeAttribute('controls');
  video.play();
}

function pausemp4(video) {
  // video.removeAttribute('autoplay');addEvent
  // video.removeAttribute('loop');
  video.pause();
  video.currentTime = 0;
}


function pauseAndHideAllMp4s() {
  var videos = document.querySelectorAll('[data-gif]');
  [].forEach.call(videos, function(video) {
    video.pause();
    video.currentTime = 0;
  });
  superboxes.forEach(box => {
    box.classList.remove('gifplaying');
  });
}
